import { SchoolOutlineIcon } from './SchoolOutlineIcon';

/**
 * author: Google
 * id 282BA7AF-AFFD-491F-BA34-8DFD88378AFF
 * name school-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/school-outline.svg
 * tags
 */
export const UniversityOutlineIcon = SchoolOutlineIcon;
export default UniversityOutlineIcon